import type { ErrorFallbackProps } from "@circle-react/components/shared/ErrorBoundary";
import { ErrorBoundaryFallback } from "@circle-react/components/shared/ErrorBoundaryFallback";

import { t } from "@/i18n-js/instance";

const LOCALE_ROOT = "sidebar_v3.error_boundary";

export const SidebarV3ErrorFallback = ({
  error,
  resetState,
}: ErrorFallbackProps) => (
  <ErrorBoundaryFallback
    title={t([LOCALE_ROOT, "title"])}
    description={t([LOCALE_ROOT, "description"])}
    error={error}
    resetState={resetState}
    titleVariant="heading-sm"
    className="h-full justify-center p-4"
  />
);
